import type { SyntheticEvent } from "react";

/**
 * The picture every talent without a photo gets (founder pick, 1.5.2): a
 * drawn person in headphones on the purple-to-pink gradient — never an
 * initial letter, never a broken-image glyph. Vector, so it stays sharp at
 * the tab bar's 22px and the public page's 100px alike. Fans' own pictures
 * (FanAvatar, Top Fans) keep their own fallback.
 */
export const DEFAULT_AVATAR_SRC = "/default-avatar.svg";

/** onError for a talent photo: a photo that fails to load shows the drawing. */
export function showDefaultAvatar(e: SyntheticEvent<HTMLImageElement>) {
  const img = e.currentTarget;
  if (!img.src.endsWith(DEFAULT_AVATAR_SRC)) img.src = DEFAULT_AVATAR_SRC;
}
